import { isUrlValid } from '@zaplify/utils';
import { isEmailCorrect } from '../../services/utils/emailHelper';

export const TextFieldNames = {
    email: 'email',
    password: 'password',
};

export const validateEmail = (email) => {
    let errorMessage = '';
    if (!email) {
        errorMessage = 'Required';
    } else if (!isEmailCorrect(email)) {
        errorMessage = 'Invalid email address';
    }
    return errorMessage;
};

export const validateUrl = (website) => {
    let errorMessage = '';
    if (!website) {
        errorMessage = 'Required';
    } else if (!isUrlValid(website)) {
        errorMessage = 'Invalid website URL';
    }
    return errorMessage;
};

export const validatePassword = (password) => {
    let errorMessage = '';
    if (!password) {
        errorMessage = 'Required';
    } else if (password.length < 6) {
        errorMessage = 'Your password must contain at least 6 characters';
    }
    return errorMessage;
};

export const validateRequired = (field, errorMessage = 'Required') => (!field ? errorMessage : '');

export const validateCombined = (formValues, setErrors) => {
    let errors = {
        email: '',
        password: '',
        checkbox: '',
    };
    errors.email = validateEmail(formValues.email);
    errors.password = validatePassword(formValues.password);
    errors.checkbox = validateRequired(formValues.checkbox, 'You must accept the terms in order to proceed');

    setErrors(errors);
    return errors.email === '' && errors.password === '' && errors.checkbox === '';
};

export const validateOnChange = (event, errors, setErrors) => {
    let newError = { ...errors };
    switch (event.target.name) {
        case TextFieldNames.email:
            if (errors.email !== '') {
                newError.email = validateEmail(event.target.value);
            }
            break;
        case TextFieldNames.password:
            if (errors.password !== '') {
                newError.password = validatePassword(event.target.value);
            }
            break;
        default:
            break;
    }
    setErrors(newError);
};
